import EmptyLandingPage from './EmptyLandingPage';

export default EmptyLandingPage;
